import { render } from "./AchievementView.vue?vue&type=template&id=1cdaff2b&ts=true"
import script from "./AchievementView.vue?vue&type=script&lang=ts"
export * from "./AchievementView.vue?vue&type=script&lang=ts"

import "./AchievementView.vue?vue&type=style&index=0&id=1cdaff2b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__